import { render, staticRenderFns } from "./takvim.vue?vue&type=template&id=0b48f986&scoped=true&"
import script from "./takvim.vue?vue&type=script&lang=js&"
export * from "./takvim.vue?vue&type=script&lang=js&"
import style0 from "./takvim.vue?vue&type=style&index=0&id=0b48f986&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b48f986",
  null
  
)

export default component.exports